import { gql } from '@urql/core';
import React from 'react';
import { Espin_Notification_Type_Enum, NotificationCardFragment } from '../../../generated/spin-graphql';
import { FollowerCard } from './social-cards/FollowerCard';
import { InterestedInCard } from './social-cards/InterestedInCard';
import { MessageCard } from './social-cards/MessageCard';
import { ProfileViewCard } from './social-cards/ProfileViewCard';
import { RecruitmentCard } from './social-cards/RecruitmentCard';
import { ConversationStartedMessageCard } from './social-cards/ConversationStartedCard';

type Props = {
    notification: NotificationCardFragment;
};

gql`
    fragment NotificationCard on espin_notification {
        id
        notification_type
        viewed_at
        ...InterestedInCard
        follows {
            ...FollowerCard
        }
        profile_views {
            ...ProfileViewCard
        }
        messages {
            ...MessageCard
        }
    }
`;

export const NotificationCard: React.FC<Props> = ({ notification }) => {
    return (
        <>
            {notification.notification_type === Espin_Notification_Type_Enum.Follow &&
                notification.follows.length > 0 && (
                    <FollowerCard follow={notification.follows[0]} viewedAt={notification.viewed_at} />
                )}
            {notification.notification_type === Espin_Notification_Type_Enum.ProfileView && (
                <ProfileViewCard profileView={notification.profile_views[0]} viewedAt={notification.viewed_at} />
            )}
            {notification.notification_type === Espin_Notification_Type_Enum.Message && (
                <MessageCard message={notification.messages[0]} viewedAt={notification.viewed_at} />
            )}
            {notification.notification_type === Espin_Notification_Type_Enum.Recruitment && (
                <RecruitmentCard viewedAt={notification.viewed_at} />
            )}
            {notification.notification_type === Espin_Notification_Type_Enum.InterestedIn && (
                <InterestedInCard interestedIn={notification} viewedAt={notification.viewed_at} />
            )}
            {notification.notification_type === Espin_Notification_Type_Enum.ConversationStarted && (
                <ConversationStartedMessageCard conversationStarted={notification} viewedAt={notification.viewed_at} />
            )}
        </>
    );
};
